export default function MySQL_SQRT() {
  return (
    <div>
      <h2>MySQL_SQRT</h2>    </div>
  );
}